import { exists } from '@/mixins/exists';

export const errorHandling = {
    mixins: [exists],
    data() {
        return {
            serverError:
                'There was a problem with the server. Please try again later.',
            clientError:
                'There seems to be a problem with the input data. Either try ' +
                'again or refresh the page and try. We apologize for the inconvenience.',
            validationErrors: {},
        };
    },
    methods: {
        isValidationError(resp) {
            return (
                this.exists(resp.data) &&
                this.exists(resp.data.validation_errors)
            );
        },

        handleValidationErrors(errors) {
            errors.forEach((err) => {
                this.validationErrors[err.field] = err.errors;
            });
        },

        handleErrorLogging(error) {
            if (error.response) {
                let message = '';

                console.log(
                    'Error debugging:  Request made => server responded'
                );
                console.log('Status Code: ', error.response.status);

                if (error.response.data) {
                    if (error.response.data.message) {
                        message = error.response.data.message;
                    } else if (error.response.data.error) {
                        message = error.response.data.error;
                    } else {
                        message = error.message;
                    }
                }

                console.log('Error message: ', message);

                if (process.env.NODE_ENV === 'development') {
                    console.log('Data: ', error.response.data);
                    console.log('Headers: ', error.response.headers);
                }

                return message;
            } else if (error.request) {
                console.log(
                    'Error debugging:  The request was made but no response was received'
                );

                if (process.env.NODE_ENV === 'development') {
                    console.log(error.request);
                }

                return this.serverError;
            } else {
                console.log(
                    'Error debugging:  Something happened in setting up the request that triggered an Error'
                );
                console.log('Error', error.message);

                return this.clientError;
            }
        },

        /** Returns error message(s) that get displayed. */
        handleError(error) {
            let message;
            this.validationErrors = {};

            if (
                error &&
                error.response &&
                this.isValidationError(error.response)
            ) {
                this.handleValidationErrors(
                    error.response.data.validation_errors
                );

                message = 'Please fix the issues above before submitting.';
            } else {
                message = this.handleErrorLogging(error);
            }

            console.log(message);

            return message;
        },
    },
};
